import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import MinhasRedacoesMain from '../components/minhas-redacoes';
import { useEffect } from 'react';
import { retrieveToken } from './../hooks/use-token';
import { useNavigate } from 'react-router-dom';

const MinhasRedacoes = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const tokenApi = retrieveToken();
    if (!tokenApi) {
      navigate("/entrar");
    }
  }, []);

  return (
    <Wrapper>
      <SEO pageTitle={'Minhas Redaçoes'} />
      <MinhasRedacoesMain/>
    </Wrapper>
  );
};

export default MinhasRedacoes;